"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assignCodeToError = void 0;
const errors_1 = require("./errors");
function assignCodeToError(code, error) {
    if (Object.isFrozen(error)) {
        throw errors_1.ERRORS.ERROR_FROZEN();
    }
    return Object.assign(error, { code });
}
exports.assignCodeToError = assignCodeToError;
